import { Checkbox, TableCell, TableHead, TableRow } from "@mui/material";
import { useContext } from "react";

import { UnknownTransaction } from "../Type";
import ContextTable from "./contextTable";

type Props = {
	data: UnknownTransaction[];
};

export const TableHeader = ({ data }: Props) => {
	const { onSelectAllRows, selected } = useContext(ContextTable);

	const numSelected = selected.length;
	const rowCount = data.length;

	return (
		<TableHead>
			<TableRow>
				{onSelectAllRows && (
					<TableCell padding='checkbox'>
						<Checkbox
							size='small'
							indeterminate={numSelected > 0 && numSelected < rowCount}
							checked={rowCount > 0 && numSelected === rowCount}
							onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
								onSelectAllRows(
									event.target.checked,
									data.map((i) => i.description)
								)
							}
						/>
					</TableCell>
				)}
				<TableCell>{"Entidad"}</TableCell>
				<TableCell align='left'>{"Descripción"}</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default TableHeader;
